import { useState, useEffect } from 'react';
import { useQuery } from 'react-query';
import { AlertType, Preference } from '../../models/DocketAlerts';
import { fetchDocketAlertPreferences } from '../../services/docketAlerts/docketAlerts.service';

interface UseDocketAlertPreferenceReturn {
  docketPreference: Preference;
  selectDocketAlert: (mode: AlertType) => void;
}

const useDocketAlertPreference = (docketCaseId: number, issuerIdNumber: number): UseDocketAlertPreferenceReturn => {
  const storageKey = `docketPreference_${docketCaseId}`;
  const { data: fetchedPreferences } = useQuery<Preference, Error>(
    ['docketAlertPreferences', docketCaseId, issuerIdNumber],
    () => fetchDocketAlertPreferences(docketCaseId, issuerIdNumber),
    { refetchOnWindowFocus: true }
  );

  const [docketPreference, setDocketPreference] = useState<Preference>(() => {
    const savedPreference = localStorage.getItem(storageKey);
    return savedPreference ? JSON.parse(savedPreference) : { mode: AlertType.None };
  });

  // Update local state and localStorage when fetchedPreferences change
  useEffect(() => {
    if (fetchedPreferences) {
      setDocketPreference(fetchedPreferences);
      localStorage.setItem(storageKey, JSON.stringify(fetchedPreferences));
    }
  }, [fetchedPreferences, storageKey]);

  // Persist changes to localStorage
  useEffect(() => {
    localStorage.setItem(storageKey, JSON.stringify(docketPreference));
  }, [docketPreference, storageKey]);

  const selectDocketAlert = (mode: AlertType): void => {
    setDocketPreference({ mode });
  };

  return {
    docketPreference,
    selectDocketAlert,
  };
};

export default useDocketAlertPreference;
